var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "common" },
    [
      _c("search-form", {
        attrs: { formConfig: _vm.formConfig, source: _vm.searchData },
        on: { handleSearchSigner: _vm.handleSearchSigner, search: _vm.search }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "table-common" },
        [
          _c("a-table", {
            attrs: {
              size: "middle",
              columns: _vm.columns,
              "data-source": _vm.tableData,
              pagination: _vm.pagination,
              loading: _vm.loading,
              "row-key": function(record, index) {
                return record.id + "_" + index
              },
              bordered: "",
              locale: { emptyText: "暂无数据" }
            },
            on: { change: _vm.handleTableChange },
            scopedSlots: _vm._u([
              {
                key: "signTime",
                fn: function(text) {
                  return [
                    _vm._v(_vm._s(_vm._f("dateFormat")(text, "YYYY-mm-dd")))
                  ]
                }
              },
              {
                key: "platformUserNm",
                fn: function(text, record) {
                  return [
                    +record.lawTxtType === 16
                      ? _c("span", [
                          _vm._v(
                            "\n              " +
                              _vm._s(record.platformUserNm) +
                              "\n          "
                          )
                        ])
                      : [
                          _c("span", [_vm._v(_vm._s(record.buyerUserNm))]),
                          _vm._v(" "),
                          record.buyerUserNm &&
                          (record.sellerUserMn || record.fctrNm)
                            ? _c("span", [_vm._v("、")])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(record.sellerUserMn))]),
                          _vm._v(" "),
                          record.sellerUserMn && record.fctrNm
                            ? _c("span", [_vm._v("、")])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(record.fctrNm))])
                        ]
                  ]
                }
              },
              {
                key: "artcTtl",
                fn: function(text) {
                  return [_vm._v("《" + _vm._s(text) + "》")]
                }
              },
              {
                key: "signStCd",
                fn: function(text) {
                  return [_vm._v(_vm._s(_vm._f("signStCdTrans")(text)))]
                }
              },
              {
                key: "operation",
                fn: function(text, record) {
                  return [
                    record.signStCd == 1
                      ? _c(
                          "a",
                          {
                            on: {
                              click: function($event) {
                                return _vm.download(record)
                              }
                            }
                          },
                          [_vm._v("下载")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    +record.signStCd === 0
                      ? _c(
                          "a-button",
                          {
                            staticClass: "btn-blue-line",
                            attrs: {
                              disabled:
                                +record.lawTxtType === 7 ||
                                +record.lawTxtType === 11 ||
                                +record.lawTxtType === 22 ||
                                +record.lawTxtType === 10
                            },
                            on: {
                              click: function($event) {
                                return _vm.toSign(record)
                              }
                            }
                          },
                          [_vm._v("去签署")]
                        )
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              class: {
                "table-total": _vm.pagination.total > 0,
                "table-total-none": _vm.pagination.total == 0
              }
            },
            [
              _vm._v("\n      共有记录：\n      "),
              _c("span", { staticClass: "text-color-blue" }, [
                _vm._v(_vm._s(_vm.pagination.total) + " 条")
              ])
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-37ac8fc6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37ac8fc6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/inquiry/legaltexts-main.vue
// module id = nqNA
// module chunks = 1